module.exports = __webpack_public_path__ + "static/media/banner-img.86bd3bb8.png";